<link
    href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0"
    rel="stylesheet"
/>

<div class="header">
    <div class="container-left">
        <picture class="logo">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M14.586 7.31107H11.1336C10.782 5.71077 9.28136 4.63227 7.65246 4.80912C6.02356 4.98597 4.78938 6.36139 4.78938 7.99986C4.78938 9.63834 6.02356 11.0138 7.65246 11.1906C9.28136 11.3675 10.782 10.289 11.1336 8.68866H14.5865C14.2407 12.0179 11.4187 14.623 7.99972 14.623C4.34833 14.623 1.37759 11.6522 1.37759 8.00055C1.37759 4.34888 4.34833 1.37759 7.99972 1.37759C10.402 1.37917 12.6157 2.67979 13.7864 4.77753H15.324C14.044 1.87519 11.1718 0.0016865 7.99972 0C3.58874 0 0 3.58819 0 8C0 12.4118 3.58819 16 7.99972 16C12.4113 16 16 12.411 16 8C16 7.7687 15.9892 7.53906 15.9696 7.30996L14.586 7.31107ZM7.99972 9.83163C6.98814 9.83163 6.16809 9.01158 6.16809 8C6.16809 6.98842 6.98814 6.16837 7.99972 6.16837C9.01131 6.16837 9.83136 6.98842 9.83136 8C9.83029 9.01114 9.01086 9.83057 7.99972 9.83163Z"
                    fill="white"
                />
            </svg>
        </picture>
        <div class="title">
            {{ title() }}
        </div>
    </div>

    <div class="container-right">
        @for (rootMenuItem of menuItems(); track rootMenuItem.title) {
            @let i = $index;
            @if (helper.isParentItem(rootMenuItem)) {
                <div
                    class="menu"
                    (click)="toggleNavbar($event, i)"
                    (touchstart)="toggleNavbar($event, i)"
                    (mouseenter)="toggleNavbar($event, i, true)"
                    (mouseleave)="toggleNavbar($event, i, false)"
                >
                    <onego-menu-title-icon [item]="rootMenuItem" />

                    @if (rootMenuItem.subItems?.length) {
                        <div class="menu-items-container">
                            <div class="menu-items" [class]="{ hidden: navbarOpen() !== i }">
                                @for (item of rootMenuItem.subItems; track item) {
                                    <onego-menu-item
                                        [item]="item"
                                        [index]="i"
                                        [toggleNavbar]="toggleNavbar"
                                        (click)="$event.stopPropagation()"
                                    />
                                }
                            </div>
                        </div>
                    }
                </div>
            } @else {
                <onego-menu-item [item]="rootMenuItem" [index]="i" [toggleNavbar]="toggleNavbar" />
            }
        }
    </div>
</div>
